import { render } from "./CategoryList.vue?vue&type=template&id=231f8538&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=231f8538&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231f8538"]])

export default __exports__